<div *ngIf="loadingInit" class="fullscreen-overlay">
  <div class="flip-spinner">
    <div class="rect"></div>
  </div>
</div>
<div *ngIf="userAccess" class="container-fluid mt-2 body-bg">
  <router-outlet></router-outlet>

</div>
<div *ngIf="userAccess==false"
  style="text-align: center;margin-top: 15px;font-size: 20px;color: #978B7F;margin-top: 75px;">
  {{Notautorized}}
</div>


<button type="button" hidden="true" data-toggle="modal" data-target="#httpErrorInterceptors" id="errorPopup"
  class="btn btn-custom btn-custom-md btn-blue">

</button>
<div class="modal fade" id="httpErrorInterceptors" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
 >
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Error! {{getItem("errorCode")}}
          <button type="button" class="close" id="closeCmpSites" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <span>An unexpected error occured while processing this workflow {{getItem('errorReqId')}}. Please contact
              <a href="mailto:isa@renault.com?subject=ISA - {{getItem('errorReqId')}}"
                style="text-decoration: underline;color: #47525E;">isa&#64;renault.com</a> for assistance.</span>
          </div>

          <br>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">

        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="refreshpopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          <span class="label">ReFresh Token</span>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="noreload()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (noreload())">
            <span>&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div style="font-size: large; padding-top: 20px; text-align: initial; font-weight: bold;">
            Token has Expired. Do you want to refresh?
          </div>
        </section>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm ml-2" data-dismiss="modal"
            style="margin-left: 16%;background-color: #cb4b32;" (click)="noreload()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (noreload())">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue ml-2" data-dismiss="modal"
            (click)="refreshPage()" style="margin-left: 16%;">Continue</button>
        </section>
      </div>
    </div>
  </div>
</div>
<div style="display: none;">
  <button id="btnForRefrshPopup" data-target="#refreshpopup" data-toggle="modal"></button>
</div>